// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"4d9750f1","271":"97b759bc","292":"489c483a","453":"c8ab1980","519":"f68d369f","555":"5d64d622"}[chunkId] + ".chunk.js";
};